// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1-2iW","info":"UpdateTermsInfo_info__aaXp3"};